export enum CountryChangeStatusEnum {
  new = 'new',
  completed = 'completed',
  rejected = 'rejected',
  initial = 'initial',
  changed = 'changed',
}

export interface CountryChangeStatus {
  status: CountryChangeStatusEnum;
  updatedAt?: string;
  requestedCountry?: string;
  currentCountry?: string;
}

export interface CountryChangeStatusRequest {
  newCountry: string;
  oldCountry: string;
  status: CountryChangeStatusEnum;
  userId: number;
}
